import { Skeleton, Spacer } from "@fullscript/aviary-web";

import * as styles from "../GoogleSSOButton/GoogleSSOButton.styles";

const SkeletonOrSection = () => (
  <div css={styles.GoogleSSOButton}>
    <Skeleton variant="typography" typographyType="footnote" width={64} />
    <Spacer size="small" direction="horizontal" />
    <Skeleton variant="button" width={16} height={16} />
    <Spacer size="small" direction="horizontal" />
    <Skeleton variant="typography" typographyType="footnote" width={64} />
  </div>
);

export { SkeletonOrSection };
